<template>
<div class="index">
    <div class="page_kaifa">
        <div class="top">
            <img :src="publicPath+'statics/images/devolping.png'" alt="" class="tu">
        </div>
        <div class="tips">
            <div class="sub_txt">技术大大正在努力开发中～</div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "developing",
    data() {
        return {
			publicPath: process.env.BASE_URL,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '时代记忆'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            
        } else {
            
        }
    },
    methods: {

    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
